<template>
  <div>
    <ContentHeader title="Disbursement List" />
    <table-skeleton v-if="loading"/>
    <section class="content" v-else>
      <div class="container-fluid">
        <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="card-header">
                <div class="card-tools">
                  <div class="d-flex filter-container">
                    <select
                      class="form-select mr-3 w-25 select-perpage"
                      v-model="table.perPage"
                    >
                      <option value="5">5</option>
                      <option value="10" selected>10</option>
                      <option value="20">20</option>
                      <option value="50">50</option>
                    </select>
                    <input
                      type="text"
                      name="search"
                      class="form-control w-75 search-bar"
                      placeholder="Search"
                      v-model="table.filter"
                    />
                  </div>
                </div>
              </div>
              <div class="card-body table-responsive p-0">
                <b-table
                  hover
                  responsive
                  :items="disbursement"
                  :fields="table.fields"
                  :current-page="table.currentPage"
                  :per-page="table.perPage"
                  :filter="table.filter"
                  @filtered="onFiltered"
                  show-empty
                >
                  <template #empty="scope">
                    <p class="text-center">
                      {{ scope.emptyText }}
                    </p>
                  </template>
                  <template #emptyFiltered="scope">
                    <p class="text-center">
                      {{ scope.emptyFilteredText }}
                    </p>
                  </template>
                  <template #cell(No)="data">
                    {{
                      (table.currentPage - 1) * table.perPage + data.index + 1
                    }}
                  </template>
                  <template #cell(amount)="data">
                    <p class="text-center">
                       Rp {{new Intl.NumberFormat('id-ID').format(Number(komaCok(data.value)).toFixed())}}
                    </p>
                  </template>
                  <template #cell(status)="data">
                    <div class="btn btn-warning rounded-pill" v-if="data.value == 'PENDING'">
                      PENDING
                    </div>
                    <div class="btn btn-success rounded-pill" v-else-if="data.value == 'INSTALLED'">
                      INSTALLED
                    </div>
                    <div class="btn btn-success rounded-pill" v-else-if="data.value == 'SUCCESS'">
                      SUCCESS
                    </div>
                    <div class="btn btn-danger rounded-pill" v-else-if="data.value == 'EXPIRED'">
                      EXPIRED
                    </div>
                  </template>
                  <template #cell(detail)="data">
                    <router-link :to="'/disbursemet-detail/'+data.item.id">
                      Detail
                    </router-link>
                  </template>
                </b-table>
              </div>
              <b-pagination
                v-model="table.currentPage"
                :total-rows="table.totalRows"
                :per-page="table.perPage"
                class="my-0 p-3"
              ></b-pagination>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import ContentHeader from "@/components/molecules/ContentHeader.vue";
import apiClient from '../services/ApiServices';
import TableSkeleton from '../components/loading-screen/TableSkeleton.vue';

export default {
  components: {
    ContentHeader,
    TableSkeleton
  },
  data() {
    return {
      loading: true,
      disbursement: [],
      table: {
        currentPage: 1,
        totalRows: 1,
        perPage: 10,
        filter: "",
        filterOn: [],
        fields: [
          "No",
          {
            key: "transaction.transaction_code",
            label: "Transaction Code",
            sortable: true,
          },
          {
            key: "transaction.product_type",
            label: "Product Type",
            sortable: true,
          },
          {
            key: "transaction.investor.name",
            label: "Investor Name",
            sortable: true,
          },
          {
            key: "transaction.deposit_amount",
            label: "Deposit amount",
            sortable: false,
          },
          {
            key: "amount",
            label:"Amount",
            sortable: false,
          },
          {
            key: "currency",
            sortable: true,
          },
          {
            key: "status",
            sortable: false,
          },
          {
            key: "detail",
            sortable: false,
          },
          // "Action",
        ],
      },
    };
  },
  async mounted() {
    try {
      let response = await apiClient.get(`${this.$user_id}/disbursement/`)
      this.disbursement = response.data.data 
      this.table.totalRows = this.disbursement.length
    } catch (error) {
      this.$swal(
        "Oooopss....",
        error.data.data.message,
        "error"
      );
    } finally {
      this.loading = false
    }
  },
  methods: {
    komaCok(data) {
      return data.toFixed(2)
    },
    onFiltered(disbursement) {
      this.table.totalRows = disbursement.length;
      this.table.currentPage = 1;
    },
    changeStatus(id) {
      const index = this.subscriptions.findIndex((item) => item.id == id);
      this.subscriptions[index].status === false
        ? (this.subscriptions[index].status = true)
        : (this.subscriptions[index].status = false);
    },
  },
};
</script>
<style scoped>
.content-wrapper{
  min-height: 400px !important;
}
.card-footer{
  padding: 0.3rem 1.25rem !important;
}
</style>
